import { render, staticRenderFns } from "./ProfileCategorySelect.vue?vue&type=template&id=2251582b&"
import script from "./ProfileCategorySelect.vue?vue&type=script&lang=js&"
export * from "./ProfileCategorySelect.vue?vue&type=script&lang=js&"
import style0 from "./ProfileCategorySelect.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports